import { render, staticRenderFns } from "./35.vue?vue&type=template&id=0c3a0a23&"
import script from "./35.vue?vue&type=script&lang=js&"
export * from "./35.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports